/* Shared, deterministic merchandising rules for the cart and PDP. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.RBKOutfitCore = api;
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  function match(products, items) {
    var sources = new Set(items.map(function (item) { return Number(item.id); }));
    if (!sources.size) return [];
    var candidates = new Map();
    products.forEach(function (product) {
      var id = Number(product.id), source = Number(product.source_id);
      if (!id || !sources.has(source) || sources.has(id) || product.available === false ||
          !(product.variants || []).some(function (variant) { return variant.available; })) return;
      if (!candidates.has(id)) candidates.set(id, { product: product, sources: new Set() });
      candidates.get(id).sources.add(source);
    });
    return Array.from(candidates.values()).filter(function (entry) {
      return entry.sources.size === sources.size;
    }).map(function (entry) { return entry.product; });
  }
  function bundleProgress(items, tiers) {
    var quantity = items.reduce(function (count, item) {
      return count + (item.eligible ? Math.max(0, Math.floor(Number(item.quantity) || 0)) : 0);
    }, 0);
    var sorted = tiers.filter(function (tier) { return tier.quantity > 0 && tier.amount > 0; })
      .slice().sort(function (a, b) { return a.quantity - b.quantity; });
    var achieved = null, next = null;
    sorted.forEach(function (tier) {
      if (quantity >= tier.quantity) achieved = tier;
      else if (!next) next = tier;
    });
    var highest = sorted[sorted.length - 1];
    return { quantity: quantity, achieved: achieved, next: next,
      remaining: next ? next.quantity - quantity : 0,
      ratio: highest ? Math.min(1, quantity / highest.quantity) : 0 };
  }
  return { match: match, bundleProgress: bundleProgress };
});
